module.exports = __webpack_public_path__ + "fonts/dystopian-black.d3ad370b.woff";